module.exports = __webpack_public_path__ + "img/Grrr.a19d0e5c.jpg";